import { useMutation } from "@tanstack/react-query";
import {
	type NsureQuestionnaireAccessRequestDTO,
	postNsureQuestionnaireAccessV2,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useQuestionnaireAccessMutation = () => {
	return useMutation({
		mutationFn: processResponse(
			(requestContract: NsureQuestionnaireAccessRequestDTO) =>
				postNsureQuestionnaireAccessV2(requestContract),
		),
	});
};
